import { render, staticRenderFns } from "./dept-picker.vue?vue&type=template&id=702fae16&scoped=true"
import script from "./dept-picker.vue?vue&type=script&lang=js"
export * from "./dept-picker.vue?vue&type=script&lang=js"
import style0 from "./dept-picker.vue?vue&type=style&index=0&id=702fae16&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702fae16",
  null
  
)

export default component.exports